import React, { Suspense, useEffect } from "react";
import { Switch, Route, BrowserRouter as Router } from "react-router-dom";
import { Redirect } from "react-router";
import routesConfig from "./routeConfig";
import CircularProgress from '@mui/material/CircularProgress';
import { ToastContainer } from "react-toastify";
import { MainProtectedLayout } from "../layouts/MainProtectedLayout";
import authService from "../services/auth-service";

import "react-toastify/dist/ReactToastify.css";

// Login routes use their own LoginLayoutRoute; protected routes share a single MainProtectedLayout
const LOGIN_PATHS = new Set(['/', '/login', '/signout', '/ferpa', '/password-expire', '/reset-password']);
const loginRoutes = routesConfig.filter(r => LOGIN_PATHS.has(r.path));
const protectedRoutes = routesConfig.filter(r => !LOGIN_PATHS.has(r.path));

// Stable component reference — defined at module level so React never unmounts/remounts MainProtectedLayout
const ProtectedRoutes = () => {
    if (!authService.isSessionActive()) {
        return <Redirect to="/" />;
    }
    return (
        <MainProtectedLayout>
            <Suspense
                fallback={
                    <div className="loader" style={{ height: "50vh", display: "flex", alignItems: "center", justifyContent: "center" }}>
                        <CircularProgress style={{ color:'#6AC5DA' }} />
                    </div>
                }
            >
                <Switch>
                    {protectedRoutes.map(({ exact, path, component }) => (
                        <Route
                            exact={exact}
                            path={path}
                            key={path}
                            component={component}
                        />
                    ))}
                </Switch>
            </Suspense>
        </MainProtectedLayout>
    );
};

export const Routewrapper = () => {

    const handleKeyDown = (event) => {
        if (event.keyCode === 255) {
          event.preventDefault();
          const currentUrl = window.location.origin;
          window.open(currentUrl +"/SM Lite Built Online Help/Default.htm");
        }
      };

      useEffect(() => {
        window.addEventListener('keydown', handleKeyDown);
        return () => {
          window.removeEventListener('keydown', handleKeyDown);
        };
      }, []);

    return (
        <>
            <Suspense
                fallback={
                    <div className="loader" style={{ height: "100vh" }}>
                        <CircularProgress style={{ color:'#6AC5DA' }} />
                    </div>
                }
            >
                <Router basename={'#'}>
                    <Switch>
                        {/* Login routes — each with its own LoginLayout */}
                        {loginRoutes.map(({ Layout, exact, path, component }) => (
                            <Layout
                                exact={exact}
                                path={path}
                                component={component}
                                key={path}
                            />
                        ))}

                        {/* All protected routes — single shared MainProtectedLayout */}
                        <Route component={ProtectedRoutes} />
                    </Switch>
                </Router>
            </Suspense>
            <ToastContainer position="top-center" style={{ width: '600px' }} autoClose={3000}
                limit={5}
                hideProgressBar={true} newestOnTop={false} closeOnClick
                rtl={false} pauseOnFocusLoss draggable pauseOnHover
            />
        </>
    )
}
